export const config = {
  api: {
    baseUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000',
    kmsUrl:
      import.meta.env.VITE_KMS_API_URL || import.meta.env.VITE_API_URL || 'http://localhost:8000',
    atsUrl:
      import.meta.env.VITE_ATS_API_URL || import.meta.env.VITE_API_URL || 'http://localhost:8002',
    timeout: 30000,
  },
  storage: {
    WORKSPACE: 'currentWorkspaceId',
    USER: 'user',
  },
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
};
